(ns portal.terms-and-conditions-page.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/List$default" :as List]
            ["@mui/material/ListItem$default" :as ListItem]
            ["@mui/material/ListItemButton$default" :as ListItemButton]
            ["@mui/material/ListItemText$default" :as ListItemText]
            ["@mui/material/Stack$default" :as Stack]
            [clojure.string :as str]
            [common.widgets.markdown :refer [markdown]]
            [common.widgets.page :as page]
            [reitit.frontend.easy :as r.easy]
            [shadow.resource :as res]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(def terms-md
  (res/inline "./platform_terms_20220905.md"))

(defui sidebar-item [{:keys [children]}]
  (let [text (first children)
        id (str/replace text " " "_")]
    ($ ListItem {:sx #js {:p 0}}
       ($ ListItemButton
          {:onClick (fn []
                      (when-let [e (.getElementById js/document id)]
                        (.scrollIntoView e #js {:behavior "smooth"})))
           :sx #js {:py 0.5}}
          ($ ListItemText text)))))

(defui sidebar []
  (let [{:keys [return] :or {return :common/login}} (use-subscribe [:router/query-parameters])]
    ($ page/content-padding
       {:component "aside"
        :sx #js {:position "sticky"
                 :top 0
                 :height "100vh"
                 :minWidth "300px"
                 :pt 3}}
       ($ Button {:href (r.easy/href return)}
          "← Go back to login page")
       ($ List {:sx #js {:mt 3}}
          ($ markdown
             {:components #js {:h2 sidebar-item}
              :allowedElements #js ["h2"]}
             terms-md)))))

(defui terms-and-conditions-page []
  ($ page/page
     {:sidebar false
      :appbar false}
     ($ Stack {:direction "row" :mx "auto" :max-width "1000px" :width "100%"}
        ($ sidebar)
        ($ page/content-padding
           {:sx #js {:pt 3}}
           ($ markdown terms-md)))))
